#import "../fragments/ImageFragment.gql"
#import "../fragments/SearchPerformerFragment.gql"
query SearchAll($term: String!, $limit: Int = 5) {
  searchPerformers(term: $term, limit: $limit) {
    count
    performers {
      ...SearchPerformerFragment
    }
  }
  searchScenes(term: $term, limit: $limit) {
    count
    scenes {
      id
      release_date
      title
      deleted
      duration
      code
      images {
        ...ImageFragment
      }
      studio {
        id
        name
      }
      performers {
        as
        performer {
          name
        }
      }
    }
  }
}
